

import { ScrollArea } from '@/components/ui/scroll-area';
import { Card, CardContent } from '@/components/ui/card';

const TermsOfService = () => {
  return (
    <section id="terms" className="mb-16">
      <h2 className="text-2xl font-bold mb-6 pb-2 border-b border-neutral-200 text-left">Terms of Service</h2>
      
      <Card className="border shadow-sm">
        <CardContent className="p-0">
          <ScrollArea className="h-[400px] rounded-md">
            <div className="p-6 text-left">
              <p className="text-neutral-600 mb-4">
                Welcome to The Mat Monster, owned and operated by Team Jumo, Inc. ("we," "our," or "us").
                These Terms of Service ("Terms") govern your use of our mobile app, website, and services (collectively, "The Mat Monster" or "the app"). By creating an account or using the app, you agree to these Terms.
              </p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">1. Eligibility</h3>
              <p className="text-neutral-600 mb-6">
                You must be at least 13 years old to use The Mat Monster. If you are under 18, you agree to use the app only with the supervision of a parent or legal guardian.
              </p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">2. Account Responsibilities</h3>
              <p className="text-neutral-600 mb-6">
                You're responsible for any activity under your account. Keep your credentials secure, and let us know right away if you suspect unauthorized access.
              </p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">3. Subscriptions & Payments</h3>
              <p className="text-neutral-600 mb-2">Certain features require payment. We will:</p>
              <ul className="list-disc pl-6 mb-4 text-neutral-600">
                <li>Clearly disclose prices before purchase</li>
                <li>Auto-renew subscriptions unless you cancel</li>
                <li>Let you manage subscriptions via your app store</li>
                <li>Defer refund requests to platform policies (e.g., Apple, Google)</li>
              </ul>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">4. User Content</h3>
              <p className="text-neutral-600 mb-2">
                You own the content you create or upload — including journal entries, notes, and instructional materials.
              </p>
              <p className="text-neutral-600 mb-2">
                By uploading content, you grant us a non-exclusive, worldwide license to store, display, and use it within the app.
              </p>
              <p className="text-neutral-600 mb-2">
                If your content is approved for monetization (e.g., tutorials or downloads), you may be eligible to earn a commission or revenue share, subject to additional terms.
              </p>
              <p className="text-neutral-600 mb-2">
                Important: Uploading content does not guarantee earnings. We reserve the right to approve, reject, or remove content from monetization or public access at any time.
              </p>
              <p className="text-neutral-600 mb-6">
                We may also use aggregated, anonymized insights from public content to improve app features and user experience.
              </p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">5. Privacy and Data Use</h3>
              <p className="text-neutral-600 mb-2">We value your privacy.</p>
              <ul className="list-disc pl-6 mb-4 text-neutral-600">
                <li>We do not sell or share your data for marketing</li>
                <li>We anonymize or aggregate usage data when possible</li>
                <li>We only share information with vendors we trust</li>
              </ul>
              <p className="text-neutral-600 mb-6">
                Your use of the app is subject to our Privacy Policy
              </p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">6. Intellectual Property</h3>
              <p className="text-neutral-600 mb-2">
                All branding, structure, and core functionality of The Mat Monster are owned by Team Jumo, Inc. You may not copy or distribute any part of the app without permission.
              </p>
              <p className="text-neutral-600 mb-6">
                You retain ownership of your uploaded content but grant us limited rights to use it within the platform.
              </p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">7. Assumption of Risk</h3>
              <p className="text-neutral-600 mb-2">
                This app is for informational and training purposes. Martial arts and physical activity involve risk of injury. You agree to train responsibly and assume full responsibility for your safety.
              </p>
              <p className="text-neutral-600 mb-6">
                We are not liable for injuries or outcomes related to your use of the app.
              </p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">8. Limitation of Liability</h3>
              <p className="text-neutral-600 mb-2">To the extent allowed by law:</p>
              <ul className="list-disc pl-6 mb-4 text-neutral-600">
                <li>We make no guarantees that the app will be error-free</li>
                <li>We are not responsible for lost data, downtime, or injuries</li>
                <li>Our total liability to you is limited to fees you paid us in the last 12 months (if any)</li>
              </ul>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">9. Termination</h3>
              <p className="text-neutral-600 mb-6">
                We may suspend or terminate your account if you violate these Terms or engage in misconduct. You may delete your account at any time.
              </p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">10. Changes to These Terms</h3>
              <p className="text-neutral-600 mb-6">
                We may update these Terms. If changes are significant, we'll notify you through the app or via email. Continued use means you accept the updates.
              </p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">11. Contact</h3>
              <p className="text-neutral-600 mb-2">The Mat Monster</p>
              <p className="text-neutral-600 mb-2">Email: oss@thematmonster.com</p>
              <p className="text-neutral-600 mb-6">Mailing Address: 500 E Whitestone BLVD Unit 902 Cedar Park, TX 78630</p>
            </div>
          </ScrollArea>
        </CardContent>
      </Card>
    </section>
  );
};

export default TermsOfService;
